import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-text-popup',
  templateUrl: './text-popup.component.html',
  styleUrls: ['./text-popup.component.css']
})
export class TextPopupComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
